import React from 'react'
import Link from 'next/link'

import {
  AddOutline, CloudDownloadOutline, SettingsOutline, ExitOutline
} from 'react-ionicons'
import { signOut, useSession } from 'next-auth/react'
import { createBrightSignZip } from '../lib/playerScripts'

export const AdminHeader: React.FC = () => {
  const { data: session, status } = useSession()
  const loading = status === 'loading'

  let left = null

  let right = null

  if (loading) {
    left = null
    right = (
      <div className="right">
        <p>Validating session ...</p>
        <style global jsx>
          {`

          .right {
            margin-left: auto;
          }
        `}
        </style>
      </div>
    )
  }

  if (!session) {
    right = (
      <div className="right" />
    )
  }

  if (session) {
    left = (
      <div className="left">
        <Link href="/admin">
          Admin Home
        </Link>
        <Link href="/">
          Guest Home
        </Link>
      </div>
    )
    right = (
      <div className="right">
        <Link className="adminheader-link" href="/admin/exhibition">
          <button type="submit">
            <AddOutline height="16px" width="16px" style={{ marginRight: '5px' }} />
            Exhibition
          </button>
        </Link>
        <Link className="adminheader-link" href="/admin/work">
          <button type="submit">
            <AddOutline height="16px" width="16px" style={{ marginRight: '5px' }} />
            Work
          </button>
        </Link>
        <button type="submit" onClick={createBrightSignZip}>
          <CloudDownloadOutline height="16px" width="16px" style={{ marginRight: '5px' }} />
          BrightSign Package
        </button>
        <Link className="adminheader-link" href="https://docs.accesskit.cc">
          <button type="submit">
            Docs
          </button>
        </Link>
        <Link className="adminheader-link" href="/admin/config">
          <button type="submit">
            <SettingsOutline height="16px" width="16px" />
          </button>
        </Link>
        <button onClick={() => signOut({ callbackUrl: window.location.origin })} type="submit">
          <ExitOutline height="16px" width="16px" />
        </button>
      </div>
    )
  }

  return (
    <nav>
      {left}
      {right}
    </nav>
  )
}
